// check if device is mobile
export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}
// check if device is iOS
export const isIOS = () => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}
// check if device is Android
export const isAndroid = () => {
  return /Android/i.test(navigator.userAgent)
}
// check if device is WeChat
export const isWeChat = () => {
  return /MicroMessenger/i.test(navigator.userAgent)
}
// check if device is Alipay
export const isAlipay = () => {
  return /Alipay/i.test(navigator.userAgent)
}
// check if device is Wechat Mini Program
export const isWechatMiniProgram = () => {
  return /miniProgram/i.test(navigator.userAgent)
}



// WEBPACK FOOTER //
// ./src/utils/device.js